import * as React from 'react'
import { Text, Stack } from '@doordash/design-language'
import { Interpolate } from '@doordash/lib-i18n'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../../i18n'
import { SectionContainer, ContentText } from '../../../StyleComponents'
import { BikeYourSafetyMattersImage } from '../../../images'
import { HELP_URL } from '../../../../../../constants'
import { ImageContainer, BulletList, BulletListItem } from '../../../styles'
import { CommonTextUrl } from '../../../../../atoms/common-text-url'

const LIST_ITEMS_1 = [
  i18n.t(
    i18nKeys.safetyCourse_bike_step1__au__list_item5__sub_item1__safeRiding
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step1__au__list_item5__sub_item2__safeRiding
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step1__au__list_item5__sub_item3__safeRiding
  ),
]

const stepName = 'YourSafetyMatters'

export const YourSafetyMatters = () => (
  <SectionContainer>
    <ImageContainer>
      <BikeYourSafetyMattersImage />
    </ImageContainer>
    <Text styles={Text.Styles.Bold32}>
      {i18n.t(i18nKeys.safetyCourse_bike_step1__au__heading__safetyMatters)}
    </Text>
    <ContentText>
      <Interpolate
        i18n={i18n}
        i18nKey={
          i18nKeys.safetyCourse_bike_step1__au__description1__safetyMatters
        }
        components={[
          <Text
            weight={Text.Weights.Bold}
            display={Text.DisplayModes.Inline}
            styles={Text.Styles.SectionSubtext}
          />,
        ]}
      />
    </ContentText>
    <ContentText>
      <Interpolate
        i18n={i18n}
        i18nKey={
          i18nKeys.safetyCourse_bike_step1__au__description2__safetyMatters
        }
        components={[<CommonTextUrl url={HELP_URL} />]}
      />
    </ContentText>

    <Text styles={Text.Styles.Bold32}>
      {i18n.t(i18nKeys.safetyCourse_bike_step1__au__heading__safeRiding)}
    </Text>
    <ContentText>
      {i18n.t(i18nKeys.safetyCourse_bike_step1__au__description__safeRiding)}
    </ContentText>

    <Stack>
      <BulletList mb="XxSmall">
        <BulletListItem>
          <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
            {i18n.t(
              i18nKeys.safetyCourse_bike_step1__au__list_item1__safeRiding
            )}
          </Text>
        </BulletListItem>
      </BulletList>
      <ContentText>
        {i18n.t(i18nKeys.safetyCourse_bike_step1__au__list_item1__safeRiding)}
      </ContentText>
    </Stack>

    <Stack>
      <BulletList mb="XxSmall">
        <BulletListItem>
          <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
            {i18n.t(
              i18nKeys.safetyCourse_bike_step1__au__list_item2__safeRiding
            )}
          </Text>
        </BulletListItem>
      </BulletList>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_bike_step1__au__list_item2__description__safeRiding
        )}
      </ContentText>
    </Stack>

    <Stack>
      <BulletList mb="XxSmall">
        <BulletListItem>
          <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
            {i18n.t(
              i18nKeys.safetyCourse_bike_step1__au__list_item3__safeRiding
            )}
          </Text>
        </BulletListItem>
      </BulletList>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_bike_step1__au__list_item3__description__safeRiding
        )}
      </ContentText>
    </Stack>

    <Stack>
      <BulletList mb="XxSmall">
        <BulletListItem>
          <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
            {i18n.t(
              i18nKeys.safetyCourse_bike_step1__au__list_item4__safeRiding
            )}
          </Text>
        </BulletListItem>
      </BulletList>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_bike_step1__au__list_item4__description__safeRiding
        )}
      </ContentText>
    </Stack>

    <Stack>
      <BulletList mb="XxSmall">
        <BulletListItem>
          <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
            {i18n.t(
              i18nKeys.safetyCourse_bike_step1__au__list_item5__safeRiding
            )}
          </Text>
        </BulletListItem>
      </BulletList>
      <Stack>
        <ContentText>
          {i18n.t(
            i18nKeys.safetyCourse_bike_step1__au__list_item5__description1__safeRiding
          )}
        </ContentText>

        {LIST_ITEMS_1.map((item, index) => (
          <ContentText key={`${stepName}_LIST_ITEMS_1_${index}`}>
            {item}
          </ContentText>
        ))}
      </Stack>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_bike_step1__au__list_item5__description2__safeRiding
        )}
      </ContentText>
    </Stack>

    <Stack>
      <BulletList mb="XxSmall">
        <BulletListItem>
          <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
            {i18n.t(
              i18nKeys.safetyCourse_bike_step1__au__list_item6__safeRiding
            )}
          </Text>
        </BulletListItem>
      </BulletList>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_bike_step1__au__list_item6__description__safeRiding
        )}
      </ContentText>
    </Stack>
  </SectionContainer>
)
